import { isoToDateString, isoToDateTimeString } from "utils/date";

export default [

  { field: 'name', headerAlign: 'center', headerName: 'Касса', flex: 1,
    valueGetter: (value, row) => `${row.model} - ЗН ${row.factoryNumber}`},

  { field: 'setupAt', headerAlign: 'center', headerName: 'Установка', flex: 1, align: 'right',
    valueGetter: (value) => isoToDateTimeString(value)}

];    